module.exports = __webpack_public_path__ + "static/media/pic9.ca4d7183.webp";